import React from 'react';
import { makeStyles, CircularProgress } from '@material-ui/core';

const useStyles = makeStyles({
  progress: {
    position: 'absolute',
    top: '46.5%',
    left: '46.5%',
  },
});

const CenteredLoading = () => {
  const classes = useStyles();

  return (
    <CircularProgress className={classes.progress} />
  );
};

export default CenteredLoading;
